import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from './SearchComponent';
import { countryList } from '../../constantsApp/countryList';
import listCurrency from '../../constantsApp/currency.json';

const currencyOptions = listCurrency.currencies.map(item => ({
  value: item.code,
  label: `${item.name} (${item.code})`,
}));

class PackageSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.id',
      name: 'id',
    },
    {
      label: 'common:label.name',
      name: 'name',
    },
    {
      label: 'common:label.salesChannel',
      name: 'salesChannel',
      tOptions: 'selections:salesChannel',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'common:label.marketSegment',
      name: 'marketSegment',
      tOptions: 'selections:marketSegment',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'common:label.accountType',
      name: 'accountType',
      tOptions: 'selections:accountType',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'common:label.accountSubType',
      name: 'accountSubType',
      tOptions: 'selections:accountSubType',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'common:label.status',
      name: 'status',
      tOptions: 'selections:statusPricing',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'common:label.country',
      name: 'country',
      type: 'select',
      options: countryList,
    },
    {
      label: 'common:label.currency',
      name: 'currency',
      type: 'select',
      options: currencyOptions,
    },
  ];

  btnSpan = 'col-md-9';
}

PackageSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

PackageSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(PackageSearchForm);
